var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "player share", class: { show: _vm.show } }, [
    _c("div", { staticClass: "container" }, [
      _c("i", {
        staticClass: "icon-close-1 player-close",
        on: { click: _vm.playerClose }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "image-area" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "scroll",
                rawName: "v-scroll",
                value: _vm.zoom,
                expression: "zoom"
              }
            ],
            ref: "imageBox",
            staticClass: "image-swiper",
            attrs: { id: "imageBox" }
          },
          [
            _c(
              "swiper",
              {
                ref: "mySwiper",
                attrs: { options: _vm.swiperOption },
                on: { transitionEnd: _vm.imageTransitionEnd }
              },
              _vm._l(_vm.images, function(image) {
                return _c("swiper-slide", { key: image.id }, [
                  _c("div", { staticClass: "image-wrapper" }, [
                    _c("img", {
                      staticClass: "swiper-image",
                      style: { transform: "scale(" + image.imageScale + ")" },
                      attrs: { src: image.middleUrl, alt: "" }
                    })
                  ])
                ])
              }),
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "swiper-nav left" }, [
          _c(
            "div",
            {
              staticClass: "nav-container",
              class: { grey: _vm.index <= 0 },
              on: {
                click: function($event) {
                  return _vm.navImage(-1)
                }
              }
            },
            [_c("i", { staticClass: "icon-prev" })]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "swiper-nav right" }, [
          _c(
            "div",
            {
              staticClass: "nav-container",
              class: { grey: _vm.index >= _vm.images.length - 1 },
              on: {
                click: function($event) {
                  return _vm.navImage(1)
                }
              }
            },
            [_c("i", { staticClass: "icon-next" })]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-832e17de", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-832e17de","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notebook/ShareImagePlayer.vue
// module id = null
// module chunks = 